require("./postcodeselector.scss");

class PostcodeSelector {
	constructor() {
		this.readArea = document.querySelector('[data-role="postcode-selector-read"]');
		this.editArea = document.querySelector('[data-role="postcode-selector-edit"]');
		this.btnCancel = document.querySelector('[data-role="postcode-selector-edit-cancel"]');
		this.btnSave = document.querySelector('[data-role="postcode-selector-edit-save"]');
		this.postCode = document.querySelector('[data-role="txt-postcode-selector"]');
		this.loading = document.querySelector('[data-role="postcode-selector-loading"]');

		this.readArea.querySelector('a').addEventListener('click', (evt) => {
			this.toggle(evt);
		});

		this.btnCancel.addEventListener('click', (evt) => {
			this.toggle(evt);
		});

		this.btnSave.addEventListener('click', (evt) => {
			this.save(evt);
		});
	}

	toggle(evt) {
		this.readArea.classList.toggle('d-none');
		this.editArea.classList.toggle('d-none');
		evt.preventDefault();
	}

	save(evt) {
		if (!this.editArea.checkValidity())
			return;

		this.btnSave.classList.toggle('d-none');
		this.btnCancel.classList.toggle('d-none');

		this.loading.classList.toggle('d-none');

		let url = this.editArea.getAttribute('data-url');
		let model = {
			postcode: this.postCode.value
		};
		$.ajax({
			type: "POST",
			url: url,
			async: false,
			contentType: 'application/json',
			data: JSON.stringify(model),
			success: (results) => {
				location.reload();
			},
			error: (ef) => {
				alert('An error occurred');
				console.log(ef);
			}
		});
		evt.preventDefault();
	}
}
window.addEventListener("load", new PostcodeSelector());